import { takeEvery } from 'redux-saga/effects';

export default function* sagas() {
  yield takeEvery('TEST', () => {});
}
